import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import styles from './ResetPasswordPage.module.css'; // Crie um CSS básico ou use inline

const ResetPasswordPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
    const [msg, setMsg] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setMsg("As senhas não coincidem.");
            return;
        }
        
        setStatus('loading');
        try {
            const res = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPassword })
            });
            const data = await res.json();
            
            if (res.ok) {
                setStatus('success');
                setTimeout(() => navigate('/'), 3000); // Redireciona para Home/Login
            } else {
                setStatus('error');
                setMsg(data.error || "Erro ao redefinir.");
            }
        } catch (error) {
            setStatus('error');
            setMsg("Erro de conexão.");
        }
    };

    if (!token) return <div style={{color:'white', textAlign:'center', marginTop:'50px'}}>Link inválido.</div>;

    return (
        <div style={{
            display: 'flex', justifyContent: 'center', alignItems: 'center', 
            height: '100vh', background: '#000', color: '#fff'
        }}>
            <div style={{
                background: '#121212', padding: '40px', borderRadius: '12px', 
                border: '1px solid #333', maxWidth: '400px', width: '90%'
            }}>
                <h2 style={{marginBottom: '20px', textAlign: 'center'}}>Nova Senha</h2>
                
                {status === 'success' ? (
                    <div style={{color: '#4cd137', textAlign: 'center'}}>
                        <h3>Senha alterada! 🎉</h3>
                        <p>Você será redirecionado para o login...</p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                        <input 
                            type="password" 
                            placeholder="Nova Senha" 
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                            required
                            style={{padding: '12px', borderRadius: '8px', border: '1px solid #333', background: '#1E1E1E', color: 'white'}}
                        />
                        <input 
                            type="password" 
                            placeholder="Confirme a Senha" 
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            required
                            style={{padding: '12px', borderRadius: '8px', border: '1px solid #333', background: '#1E1E1E', color: 'white'}}
                        />
                        {msg && <p style={{color: '#ff4d4d', fontSize: '0.9rem'}}>{msg}</p>}
                        
                        <button 
                            type="submit" 
                            disabled={status === 'loading'}
                            style={{
                                padding: '12px', borderRadius: '8px', border: 'none', 
                                background: '#635bff', color: 'white', fontWeight: 'bold', cursor: 'pointer'
                            }}
                        >
                            {status === 'loading' ? 'Salvando...' : 'Alterar Senha'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ResetPasswordPage;